import { render, staticRenderFns } from "./CommerceModule.vue?vue&type=template&id=551896c0&scoped=true&lang=pug&"
import script from "./CommerceModule.vue?vue&type=script&lang=js&"
export * from "./CommerceModule.vue?vue&type=script&lang=js&"
import style0 from "./CommerceModule.vue?vue&type=style&index=0&id=551896c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551896c0",
  null
  
)

export default component.exports